<script>
import options from './ContentCard.options'
const componentOptions = options
export default componentOptions
</script>

<template>
  <a :href="result.url" class="be-content-card be-color-theme--white-black" :class="{'be-content-card--narrow-card-padding': narrowCardPadding}">
      <div class="be-content-card__content-wrapper">
        <div class="be-content-card__image-area-wrapper">
          <template v-if="result.topLabel?.title && result.topLabel?.colortheme">
            <div class="be-content-card__label-wrapper">
              <div class="be-content-card__label-wrapper-color-theme" :class="result.topLabel.colortheme">
                <div class="be-content-card__label">
                  <p class="be-font-label">
                    {{ result.topLabel.title }}
                  </p>
                </div>
              </div>

            </div>
          </template>

          <figure class="be-image be-image--no-border-radius be-image--4-5">

            <div class="be-image__image-wrapper">
              <picture class="be-image__img">
                <img :src="result.imageSrc" :alt="result.imageAlt">
              </picture>
            </div>

          </figure>
        </div>

        <template v-if="result.bottomLabel?.title && result.bottomLabel?.colortheme">
          <div class="be-content-card__label-wrapper be-content-card__label-wrapper--bottom">
            <div class="be-content-card__label-wrapper-color-theme" :class="result.bottomLabel.colortheme">
              <div class="be-content-card__label">
                <p class="be-font-label">
                  {{ result.bottomLabel.title }}
                </p>

              </div>
            </div>


          </div>
        </template>

        <div class="be-content-card__texts-wrapper">

          <h3 class="be-font-heading-3 be-content-card__title">
            {{ result.title }}
            <span class="be-icon be-content-card__arrow">
              <svg role="presentation" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.75 11.726h-15M13.7 5.701l6.05 6.025-6.05 6.024" stroke="#2E7948" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </span>
          </h3>
          <template v-if="result?.leader">
            <p class="be-font-paragraph-3 be-content-card__leader">
              {{ result.leader }}
            </p>
          </template>

          <template v-if="result?.iconList">
            <ul class="be-component--icon-list be-icon-list">

              <template v-for="(iconListItem, index) in result.iconList" :key="index">
                <li class="be-icon-list__item">
                    <div class="be-icon" v-html="iconListItem.svg">
                    </div>
                    <p class="be-font-paragraph-1">{{iconListItem.title}}</p>
                </li>
              </template>

            </ul>
          </template>

          <p class="be-content-card__meta-data">
              <template v-if="result?.metaData?.metaTitle">
                <span>{{ result.metaData.metaTitle }}</span>
                {{ result.metaData.dateTitle }} <time datetime="09:00">{{ result.metaData.time }}</time> {{ result.metaData.timeType }} <time datetime="2006-24-24">{{ result.metaData.date }}</time>
              </template>
            </p>

        </div>

    </div>
  </a>
</template>
